import type { IntegrationProvider } from './types';

const salesforceProvider: IntegrationProvider = {
  key: 'salesforce',
  label: 'Salesforce',
  capabilities: {
    supportsFieldMapping: true,
    supportsRoleMapping: true,
    supportsRelationshipMapping: true,
    supportsWriteback: true,
  },
  flowKeys: {
    firstSync: {
      accounts: 'first-sync-for-accounts',
      contacts: 'first-sync-for-contacts',
      deals: 'first-sync-for-deals',
      notes: 'first-sync-for-notes',
      tasks: 'first-sync-for-tasks',
      emails: 'first-sync-for-emails',
    },
    receive: {
      accounts: 'receive-account-events',
      contacts: 'receive-contact-events',
      deals: 'receive-deal-events',
      notes: 'receive-note-events',
      tasks: 'receive-task-events',
      emails: 'receive-email-events',
    },
    send: {
      accounts: 'send-account-events',
      contacts: 'send-contact-events',
    },
  },
  supportedObjects: ['accounts', 'contacts', 'companies', 'deals', 'notes', 'tasks', 'emails', 'conversation_messages', 'users'],
  activatableObjects: ['accounts', 'contacts', 'deals', 'notes', 'tasks', 'emails'],
  defaultSourceCollections: {
    accounts: 'accounts',
    contacts: 'contacts',
    deals: 'deals',
    notes: 'notes',
    tasks: 'tasks',
    emails: 'emails',
  },
  systemMappingFields: [
    { sourceFieldName: 'salesforce_url', destinationFieldName: 'salesforce_url' },
    { sourceFieldName: 'salesforce_record_id', destinationFieldName: 'salesforce_record_id' },
  ],
};

export default salesforceProvider;
